import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { NestedPageHeader } from '../../components/header/page.header';
import { TeamSetup } from '../../components/team/team-setup';
import { useBeaconRouter } from '../../route/route.hooks';

interface TeamSetupPageProps {
  id?: string;
}

const TeamSetupPage = (props: TeamSetupPageProps): ReactElement => {
  const { id } = props;
  const { i18n } = useTranslation();

  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <NestedPageHeader
        title={i18n.t('common:team_setup')}
        defaultBackRoute={
          id ? builder.getTeamMoreRoute(id) : builder.getHomeRoute()
        }
      />
      <IonContent>
        <TeamSetup id={id} />
      </IonContent>
    </IonPage>
  );
};

export { TeamSetupPage };
